import React, { useState, useEffect } from "react"
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom"
import { auth, firestore } from "./firebase"
import { signOut, onAuthStateChanged } from "firebase/auth"
import { doc, onSnapshot } from "firebase/firestore"
import {
  handleGoogleSignIn as authGoogleSignIn,
  finalizeRedirectSignIn,
} from "./utils/auth"
import Header from "./components/non-ui/Header"
import Navigation from "./components/non-ui/Navigation"
import Footer from "./components/non-ui/Footer"
import Dashboard from "./pages/(logged-in)/dashboard"
import HomeScreen from "./pages/homeScreen"
import Pricing from "./pages/Pricing" // Import the Pricing component
import Admin from "./pages/Admin"
import Demo from "./pages/Demo"
import Legal from "./pages/Legal"
import "./App.css"

function AppContent() {
  const location = useLocation();
  const [user, setUser] = useState(null)

  // Wenn der User über Redirect (Mobile) eingeloggt wurde, müssen wir das
  // Resultat einsammeln und das Firestore-User-Dokument provisionieren.
  useEffect(() => {
    finalizeRedirectSignIn()
  }, [])

  useEffect(() => {
    let unsubscribeFirestore = null

    const unsubscribeAuth = onAuthStateChanged(auth, (authUser) => {
      if (authUser) {
        // User is signed in - subscribe to Firestore user data
        const userDocRef = doc(firestore, "users", authUser.uid)
        
        unsubscribeFirestore = onSnapshot(userDocRef, (docSnap) => {
          if (docSnap.exists()) {
            // Merge Firebase Auth data with Firestore data
            const firestoreData = docSnap.data()
            setUser({
              ...authUser,
              ...firestoreData,
              uid: authUser.uid, // Ensure uid is from auth
              email: authUser.email, // Ensure email is from auth
            })
          } else {
            // No Firestore doc yet, just set auth user
            setUser(authUser)
          }
        })
      } else {
        // User is signed out
        setUser(null)
        if (unsubscribeFirestore) {
          unsubscribeFirestore()
        }
      }
    })

    return () => {
      unsubscribeAuth()
      if (unsubscribeFirestore) {
        unsubscribeFirestore()
      }
    }
  }, [])

  // Geht auf Mobile automatisch über Redirect, auf Desktop über Popup
  // und fängt `auth/popup-blocked` ab. Provisioniert das Firestore-Dokument
  // selbst, damit `configUser` hier nicht mehr nötig ist.
  // Errors werden über `alert` sichtbar gemacht — sonst scheitert z.B. ein
  // `auth/unauthorized-domain` komplett still und der User sieht „nichts
  // passiert".
  const handleGoogleSignIn = async () => {
    await authGoogleSignIn((msg) => {
      if (msg) alert(`Login error: ${msg}`)
    })
  }

  const handleSignOut = async () => {
    try {
      await signOut(auth)
      setUser(null)
    } catch (error) {
      console.error("Error during sign-out:", error.message)
    }
  }

  const isDemo = location.pathname === '/demo';
  const isLandingPage = location.pathname === '/';
  const isDashboardPage = location.pathname.startsWith('/dashboard');

  return (
    <div className={`App ${isDashboardPage ? 'App-tryon' : ''}`}>
      {isLandingPage && !isDemo && (
          <div className="announcement-bar">
            <div className="announcement-bar-inner">
              <span className="announcement-item"><span className="announcement-icon">✓</span> Now live: Viral Barbie Dance video</span>
              <span className="announcement-item"><span className="announcement-icon">★★★★★</span> Loved by 2,964+ creators</span>
              <span className="announcement-item"><span className="announcement-icon">✓</span> 326,997+ viral videos<span className="announcement-hide-narrow"> created</span></span>
            </div>
            <div className="announcement-bar-marquee">
              <div className="announcement-marquee-content">
                <span className="announcement-marquee-item"><span className="announcement-icon">✓</span> Now live: Viral Barbie Dance video</span>
                <span className="announcement-marquee-item"><span className="announcement-icon">★★★★★</span> Loved by 2,964+ creators</span>
                <span className="announcement-marquee-item"><span className="announcement-icon">✓</span> 326,997+ viral videos created</span>
                <span className="announcement-marquee-item"><span className="announcement-icon">✓</span> Now live: Viral Barbie Dance video</span>
                <span className="announcement-marquee-item"><span className="announcement-icon">★★★★★</span> Loved by 2,964+ creators</span>
                <span className="announcement-marquee-item"><span className="announcement-icon">✓</span> 326,997+ viral videos created</span>
                <span className="announcement-marquee-item"><span className="announcement-icon">✓</span> Now live: Viral Barbie Dance video</span>
                <span className="announcement-marquee-item"><span className="announcement-icon">★★★★★</span> Loved by 2,964+ creators</span>
                <span className="announcement-marquee-item"><span className="announcement-icon">✓</span> 326,997+ viral videos created</span>
              </div>
            </div>
          </div>
          )}
      <Header
        user={user}
        handleGoogleSignIn={handleGoogleSignIn}
        handleSignOut={handleSignOut}
        lightBackground={isDashboardPage || isDemo}
      />
      {!isDemo && <Navigation />}
      <Routes>
          <Route
            path="/"
            element={
              <>
                <HomeScreen />
                <Footer />
              </>
            }
          />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/pricing" element={<Pricing user={user} handleGoogleSignIn={handleGoogleSignIn} />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/legal" element={<><Legal /><Footer /></>} />
        </Routes>
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  )
}

export default App
